import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/mobile/Hamburger.scss";

const Hamburger = ({ routes = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Filter out the current route
  const filteredRoutes = routes.filter((route) => route.path !== location.pathname);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="hamburger-menu">
      {/* Hamburger Icon */}
      <button className="hamburger-icon" onClick={toggleMenu}>
        ☰
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="menu-dropdown">
          {filteredRoutes.map((route) => (
            <Link
              key={route.path}
              to={route.path}
              className="menu-item"
              onClick={() => setIsOpen(false)} // Close menu on navigation
            >
              {route.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Hamburger;
